import { DownloadOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Drawer,
  List,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";
import { Select } from "antd/es";
import Text from "antd/lib/typography/Text";
import Cookies from "js-cookie";
import { default as isEmpty } from "lodash/isEmpty";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AggregateSummary from "./AgregarteSummaryCards";
import { fetchUser } from "modules/engagement_report/engagement_stats/api_layer/api";
import {
  getActivityLogData,
  getTicketHistory,
} from "modules/dashboards/actionables/api";
import { baseURL } from "../config/index";
import { getQueryParams, isDownloadDisabled } from "modules/utilities/utility";
import useStatsStore from "modules/engagement_report/engagement_stats/store";
import ReactDatePicker from "react-datepicker";
import { useRevenueTracker } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import secureLocalStorage from "react-secure-storage";
// import ExcelDownload from "./ExcelDownload";

const RevenueTracker = () => {
  const [zeroValueData, setZeroValueData] = useState([]);
  const [cancelledData, setCancelledData] = useState([]);
  const [cancelledPriceSum, setCancelledPriceSum] = useState(0);
  const [zeroValuePriceSum, setZeroValuePriceSum] = useState(0);
  const [rtoPriceSum, setrtoPriceSum] = useState(0);
  const [rtoData, setRTOData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [zeroValueCount, setZeroValueCount] = useState(0);
  const [cancelledCount, setCancelledCount] = useState(0);
  const [rtoCount, setrtoCount] = useState(0);
  const [selectedCaseId, setSelectedCaseId] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [getLostDamagedPriceSum, setGetLostDamagedPriceSum] = useState(null);
  const [LostDamagedData, setLostDamagedData] = useState([]);
  const [lostDamagedCount, setlostDamagedCount] = useState(0);
  const [zeroVlauedateRange, setzeroVlaueDateRange] = useState(() => ({
    startDate: moment().startOf("day").toISOString(),
    endDate: moment().endOf("day").toISOString(),
  }));
  const [lostDamagedDateRange, setLostDamagedateRange] = useState(() => ({
    startDate: moment().startOf("day").toISOString(),
    endDate: moment().endOf("day").toISOString(),
  }));

  const [cancelledValueDateRange, setCancelledValueDateRange] = useState(
    () => ({
      startDate: moment().startOf("day").toISOString(),
      endDate: moment().endOf("day").toISOString(),
    })
  );
  const [rtoVlaueDateRange, setRtoVlaueDateRange] = useState(() => ({
    startDate: moment().startOf("day").toISOString(),
    endDate: moment().endOf("day").toISOString(),
  }));

  const [pageNo, setPageNo] = useState(
    parseInt(getQueryParams("pageNumber")) || 1
  );
  const [selectedCard, setSelectedCard] = useState(null);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [drawerData, setDrawerData] = useState({});

  const [isActivityLogDrawerVisible, setIsActivityLogDrawerVisible] =
    useState(false);
  const [activityLogDrawerData, setActivityLogDrawerData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const { allUsers, fetchUserData } = useStatsStore();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const currentDate = new Date(); // Current date

  // Calculate yesterday's date
  const yesterday = new Date(currentDate);
  yesterday.setDate(yesterday.getDate() - 1);

  // Calculate yesterday's 12:00 am
  const defaultStartDate = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate(),
    0,
    0,
    0
  );

  // Calculate today's 11:59 pm
  const defaultEndDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    23,
    59,
    59
  );

  const {
    _zeroValueData,
    _cancelledData,
    _rtoData,
    lostDamagedByData,
    revenueData,
    _fetchZeroValueData,
    fetchCancelData,
    _fetchRTOData,
    fetchLostDamagedBy,
    fetchRevenueReport,
  } = useRevenueTracker();
  const { setToaster } = useToast();

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
	if (_zeroValueData) {
	  setZeroValuePriceSum(_zeroValueData.priceSum);
	  setZeroValueData(_zeroValueData.data);
	  setZeroValueCount(_zeroValueData.pagination?.rowCount);
	}
  }, [_zeroValueData]);
  
  useEffect(() => {
	if (_cancelledData) {
	  setCancelledData(_cancelledData.data);
	  setCancelledCount(_cancelledData.pagination?.rowCount);
	  setCancelledPriceSum(_cancelledData.priceSum);
	}
  }, [_cancelledData]);
  
  useEffect(() => {
	if (_rtoData) {
	  setRTOData(_rtoData.data);
	  setrtoCount(_rtoData.pagination?.rowCount);
	  setrtoPriceSum(_rtoData.priceSum);
	}
  }, [_rtoData]);
  
  useEffect(() => {
	if (lostDamagedByData) {
	  setGetLostDamagedPriceSum(lostDamagedByData.priceSum);
	  setLostDamagedData(lostDamagedByData.data);
	  setlostDamagedCount(lostDamagedByData.pagination?.rowCount);
	}
  }, [lostDamagedByData]);

  const userData = useMemo(() => {
    if (isEmpty(allUsers)) return [];
    return allUsers.map((row) => ({
      key: getValue(row, "user.id"),
      first_name: getValue(row, "user.first_name"),
      email: getValue(row, "user.email"),
      phone_number: getValue(row, "user.phone_number").substring(3),
      role: getValue(row, "role.name"),
      created: getValue(row, "user.created_at"),
      is_active: getValue(row, "user.is_active"),
      doctor_type: getValue(row, "user.doctorType[0].type"),
      breakWeekDays: getValue(row, "user.meta.breakWeekDays"),
      alternate_email: getValue(row, "user.alternate_email"),
      meta: getValue(row, "user.meta"),
      tip: getValue(row, "user.meta.bio.tip"),
      description: getValue(row, "user.meta.bio.description"),
      level: getValue(row, "user.level"),
      roleId: getValue(row, "role.id"),
      is_consult_doctor: getValue(row, "user.is_consult_doctor"),
      is_consult_doctor_active: getValue(row, "user.is_consult_doctor_active"),
      deactivated: getValue(row, "user.deactivated"),
    }));
  }, [allUsers]);
  let orderValueColumn = [
    {
      title: "Order Display ID",
      dataIndex: "order_display_id",
      key: "order_display_id",
      width: 100,
      fixed: "left",
      render: (order_display_id, { case_id }) => {
        return (
          <div className="flex flex-col">
            <Link to={`/lead-details/${case_id}`}>{order_display_id}</Link>
          </div>
        );
      },
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Tickets",
      dataIndex: "case_id",
      key: "tickets",
      render: (text, record) => {
        return (
          <div className="flex flex-col">
            <Typography.Link
              onClick={() => handleGetTicket(record.case_id, record.orderId)}
            >
              Get Ticket
            </Typography.Link>
          </div>
        );
      },
    },
    {
      title: "Activity Logs",
      dataIndex: "case_id",
      key: "activity",
      render: (text, record) => {
        return (
          <div className="flex flex-col">
            <Typography.Link
              onClick={() => handleGetActivityLog(record.case_id)}
            >
              Get Activity Log
            </Typography.Link>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Sub Status",
      dataIndex: "sub_status",
      key: "sub_status",
    },
    {
      title: "Order Created At",
      dataIndex: "orderCreatedAt",
      key: "orderCreatedAt",
      render: (date) => {
        return moment(date).format("D MMM YYYY, h:mm a");
      },
    },
  ];
  const refundApplicableColumn = {
    title: "Refund Applicable",
    dataIndex: "refundApplicable",
    key: "refundApplicable",
    render: (refundApplicable) => (refundApplicable ? "True" : "False"),
  };

  const category = [
    {
      title: "Order Placed By",
      dataIndex: "order_placer_name",
      key: "order_placer_name",
    },
    {
      title: "Email(Order Placed By)",
      dataIndex: "order_placer_email",
      key: "order_placer_email",
    },
    {
      title: "Reason For Zero Value Order",
      dataIndex: "zeroValueOrderReason",
      key: "zeroValueOrderReason",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
  ];
  const userCoulmn = [
    {
      title: "Order Cancelled At",
      dataIndex: "cancelledDate",
      key: "cancelledDate",
      render: (date) => {
        return moment(date).format("D MMM YYYY, h:mm a");
      },
    },
    {
      title: "Updated By  User",
      dataIndex: "created_by_user_id",
      key: "created_by_user_id",
      render: (cancelleRequestedByUserId) => {
        const user = userData.find(
          (user) => user.key === cancelleRequestedByUserId
        );

        return user ? user.first_name : "Unknown User";
      },
    },
    {
      title: "Cancelled By User",
      dataIndex: "cancelled_by_user_id",
      key: "cancelled_by_user_id",
      render: (cancelledByUserId) => {
        const user = userData.find((user) => user.key === cancelledByUserId);

        return user ? user.first_name : "Unknown User";
      },
    },
    {
      title: "Created By  User",
      dataIndex: "created_by_user_id",
      key: "created_by_user_id",
      render: (cancelleRequestedByUserId) => {
        const user = userData.find(
          (user) => user.key === cancelleRequestedByUserId
        );

        return user ? user.first_name : "Unknown User";
      },
    },
    {
      title: "Revenue",
      dataIndex: "totalprice",
      key: "Total Price",
    },
  ];
  orderValueColumn = [...orderValueColumn];
  const OriginalPrice = {
    title: "Original Price",
    dataIndex: "originalPrice",
    key: "originalPrice",
  };
  if (
    selectedCard === "Cancelled" ||
    selectedCard === "RTO" ||
    selectedCard === "Lost/Damaged"
  ) {
    orderValueColumn.splice(orderValueColumn.length - 1, 0, ...userCoulmn);
    orderValueColumn.push(refundApplicableColumn);
  } else if (selectedCard === "Zero Value") {
    orderValueColumn.splice(orderValueColumn.length - 1, 0, ...category);
    orderValueColumn.push(OriginalPrice);
  }

  const handleGetTicket = async (caseId, orderId) => {
    try {
      const response = await getTicketHistory(caseId);

      setDrawerData(response?.data);
      setIsDrawerVisible(true);
    } catch (error) {
      console.error("Error fetching ticket data:", error);
    }
  };
  const queryParam = `pageNumber=${currentPage}&pageSize=50`;
  const handleGetActivityLog = async (caseId) => {
    try {
      setSelectedCaseId(caseId);
      const activityData = await getActivityLogData(caseId, queryParam);
      setActivityLogDrawerData(activityData?.data?.data);
      setIsActivityLogDrawerVisible(true);
    } catch (error) {
      console.error("Error fetching activity log data:", error);
    }
  };
  const handleActivityLogDrawerClose = () => {
    setIsActivityLogDrawerVisible(false);
    setActivityLogDrawerData({});
  };
  const handleDrawerClose = () => {
    setIsDrawerVisible(false);
    setDrawerData({});
  };
  useEffect(() => {
    const fetchZeroValueData = async () => {
      setLoading(true);

      try {
        await _fetchZeroValueData(
          pageNo,
          zeroVlauedateRange.startDate,
          zeroVlauedateRange.endDate,
          selectedOption
        );
      } catch (error) {
        console.error("Error fetching zero value data:", error);
      }

      setLoading(false);
    };

    const fetchCancelledData = async () => {
      setLoading(true);

      try {
        await fetchCancelData(
          pageNo,
          cancelledValueDateRange.startDate,
          cancelledValueDateRange.endDate
        );
      } catch (error) {
        console.error("Error fetching cancelled data:", error);
      }

      setLoading(false);
    };

    const fetchRTOData = async () => {
      setLoading(true);

      try {
        await _fetchRTOData(
          pageNo,
          rtoVlaueDateRange.startDate,
          rtoVlaueDateRange.endDate
        );
      } catch (error) {
        console.error("Error fetching RTO data:", error);
      }

      setLoading(false);
    };
    const getLostDamagedBy = async () => {
      setLoading(true);

      try {
        await fetchLostDamagedBy(
          pageNo,
          zeroVlauedateRange.startDate,
          zeroVlauedateRange.endDate,
          selectedOption
        );
      } catch (error) {
        console.error("Error fetching zero value data:", error);
      }

      setLoading(false);
    };

    if (selectedCard === "Zero Value") {
      fetchZeroValueData();
    } else if (selectedCard === "Cancelled") {
      fetchCancelledData();
    } else if (selectedCard === "RTO") {
      fetchRTOData();
    } else if (selectedCard === "Lost/Damaged") {
      getLostDamagedBy();
    }
  }, [
    zeroVlauedateRange,
    cancelledValueDateRange,
    rtoVlaueDateRange,
    selectedCard,
    pageNo,
    selectedOption,
  ]);

  const handleChange = (page) => {
    setPageNo(page.current);
  };

  const handleZeroValueDateFilter = () => {
    if ((startDate, endDate)) {
      setzeroVlaueDateRange({
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
      });
    } else {
      const today = moment().startOf("day").format("YYYY-MM-DD");
      const tonight = moment().endOf("day").format("YYYY-MM-DD");

      setzeroVlaueDateRange((prevDateRange) => ({
        ...prevDateRange,
        startDate: today,
        endDate: tonight,
      }));
    }
    setPageNo(1);
  };

  const handleCancelledDateFilter = () => {
    if ((startDate, endDate)) {
      setCancelledValueDateRange({
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
      });
    } else {
      const today = moment().startOf("day").format("YYYY-MM-DD");
      const tonight = moment().endOf("day").format("YYYY-MM-DD");

      setCancelledValueDateRange((prevDateRange) => ({
        ...prevDateRange,
        startDate: today,
        endDate: tonight,
      }));
    }
    setPageNo(1);
  };
  const handleLostDamagedDateFilter = (start, end) => {
    if ((startDate, endDate)) {
      setLostDamagedateRange({
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
      });
    } else {
      const today = moment().startOf("day").format("YYYY-MM-DD");
      const tonight = moment().endOf("day").format("YYYY-MM-DD");

      setLostDamagedateRange((prevDateRange) => ({
        ...prevDateRange,
        startDate: today,
        endDate: tonight,
      }));
    }
    setPageNo(1);
  };

  const handleRTODateFilter = (start, end) => {
    if ((startDate, endDate)) {
      setRtoVlaueDateRange({
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
      });
    } else {
      const today = moment().startOf("day").format("YYYY-MM-DD");
      const tonight = moment().endOf("day").format("YYYY-MM-DD");

      setRtoVlaueDateRange((prevDateRange) => ({
        ...prevDateRange,
        startDate: today,
        endDate: tonight,
      }));
    }
    setPageNo(1);
  };

  const handleCardClick = (cardId) => {
    setSelectedCard(cardId);
  };
  const handleShowMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };
  const ZeroValueTable = () => {
    return (
      <>
        <div className="w-full">
          <Table
            rowKey={(record) => {
              return record.order_display_id;
            }}
            columns={orderValueColumn}
            scroll={{ x: "max-content" }}
            dataSource={zeroValueData}
            loading={loading}
            onChange={(page) => handleChange(page)}
            expandable={{
              expandedRowRender: (record) => {
                const lineitems = JSON.parse(record.lineitems);
                return (
                  <Row style={{ margin: 0, fontSize: "0.8rem" }}>
                    {lineitems &&
                      lineitems.map((el) => (
                        <Col key={el.id}>
                          <pre id="json">
                            {JSON.stringify(el, undefined, 2)}
                          </pre>
                        </Col>
                      ))}
                  </Row>
                );
              },
            }}
            pagination={{
              current: pageNo,
              showSizeChanger: false,
              pageSize: 10,
              total: zeroValueCount || 0,
            }}
          />
        </div>
      </>
    );
  };

  const CancelledTable = () => {
    return (
      <>
        <div className="w-full">
          <Table
            rowKey={(record) => {
              return record.order_display_id;
            }}
            columns={orderValueColumn}
            scroll={{ x: "max-content" }}
            dataSource={cancelledData}
            loading={loading}
            onChange={(page) => handleChange(page)}
            expandable={{
              expandedRowRender: (record) => {
                const lineitems = JSON.parse(record.lineitems);
                return (
                  <Row style={{ margin: 0, fontSize: "0.8rem" }}>
                    {lineitems &&
                      lineitems.map((el) => (
                        <Col key={el.id}>
                          <pre id="json">
                            {JSON.stringify(el, undefined, 2)}
                          </pre>
                        </Col>
                      ))}
                  </Row>
                );
              },
            }}
            pagination={{
              current: pageNo,
              showSizeChanger: false,
              pageSize: 10,
              total: cancelledCount || 0,
            }}
          />
        </div>
      </>
    );
  };

  const RtoTable = () => {
    return (
      <>
        <div className="w-full">
          <Table
            rowKey={(record) => {
              return record.order_display_id;
            }}
            columns={orderValueColumn}
            scroll={{ x: "max-content" }}
            dataSource={rtoData}
            loading={loading}
            onChange={(page) => handleChange(page)}
            expandable={{
              expandedRowRender: (record) => {
                const lineitems = JSON.parse(record.lineitems);
                return (
                  <Row style={{ margin: 0, fontSize: "0.8rem" }}>
                    {lineitems &&
                      lineitems.map((el) => (
                        <Col key={el.id}>
                          <pre id="json">
                            {JSON.stringify(el, undefined, 2)}
                          </pre>
                        </Col>
                      ))}
                  </Row>
                );
              },
            }}
            pagination={{
              current: pageNo,
              showSizeChanger: false,
              pageSize: 10,
              total: rtoCount || 0,
            }}
          />
        </div>
      </>
    );
  };

  const LostDamagedTable = () => {
    return (
      <>
        <div className="w-full">
          <Table
            rowKey={(record) => {
              return record.order_display_id;
            }}
            columns={orderValueColumn}
            scroll={{ x: "max-content" }}
            dataSource={LostDamagedData}
            loading={loading}
            onChange={(page) => handleChange(page)}
            expandable={{
              expandedRowRender: (record) => {
                const lineitems = JSON.parse(record.lineitems);
                return (
                  <Row style={{ margin: 0, fontSize: "0.8rem" }}>
                    {lineitems &&
                      lineitems.map((el) => (
                        <Col key={el.id}>
                          <pre id="json">
                            {JSON.stringify(el, undefined, 2)}
                          </pre>
                        </Col>
                      ))}
                  </Row>
                );
              },
            }}
            pagination={{
              current: pageNo,
              showSizeChanger: false,
              pageSize: 10,
              total: lostDamagedCount || 0,
            }}
          />
        </div>
      </>
    );
  };
  const handleZeroDownloadClick = async () => {
    try {
      const email = secureLocalStorage.getItem("email");
      const data = {
        email: email,
        category: "zero_value_order_revenue_report",
        startDate: zeroVlauedateRange.startDate,
        endDate: zeroVlauedateRange.endDate,
      };
      await fetchRevenueReport(data, setToaster);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleCancelledDownloadClick = async () => {
    try {
      const email = secureLocalStorage.getItem("email");
      const data = {
        email: email,
        category: "cancelled_order_revenue_report",
        startDate: cancelledValueDateRange.startDate,
        endDate: cancelledValueDateRange.endDate,
      };
      await fetchRevenueReport(data, setToaster);
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const handlelostDamagedDownloadClick = async () => {
    try {
      const email = secureLocalStorage.getItem("email");
      const data = {
        email: email,
        category: "lost_damaged_order_revenue_report",
        startDate: lostDamagedDateRange.startDate,
        endDate: lostDamagedDateRange.endDate,
      };
      await fetchRevenueReport(data, setToaster);
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const handleRTODownloadClick = async () => {
    try {
      const email = secureLocalStorage.getItem("email");
      const data = {
        email: email,
        category: "rto_order_revenue_report",
        startDate: rtoVlaueDateRange.startDate,
        endDate: rtoVlaueDateRange.endDate,
      };
      await fetchRevenueReport(data, setToaster);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleClear = () => {
    setSelectedOption(null);
  };
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Text strong style={{ fontSize: "1.5em" }}>
            Revenue Tracker
          </Text>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {selectedCard ? (
            <Text strong style={{ fontSize: "1.5em" }}>
              {selectedCard}
            </Text>
          ) : null}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="grid gap-2 admin__post_sales__dashboard-grid"
        style={{
          marginBottom: "2%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div onClick={() => handleCardClick("Zero Value")}>
          <AggregateSummary title="Zero Value">
            <Text>
              <strong>Date: </strong>
              {moment
                .utc(zeroVlauedateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")}
              {moment
                .utc(zeroVlauedateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD") !==
              moment
                .utc(zeroVlauedateRange.endDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")
                ? ` to ${moment
                    .utc(zeroVlauedateRange.endDate)
                    .utcOffset("+05:30")
                    .format("YYYY-MM-DD")}`
                : ""}
              <br />
              <strong>Zero Value order Count: </strong>
              {zeroValueCount}
              <br />
              <strong> Total Price (INR): </strong>
              {isNaN(parseFloat(zeroValuePriceSum))
                ? 0
                : parseFloat(zeroValuePriceSum).toFixed(2)}
            </Text>
          </AggregateSummary>
        </div>
        <div onClick={() => handleCardClick("Cancelled")}>
          <AggregateSummary title="Cancelled">
            <Text>
              <strong>Date: </strong>
              {moment
                .utc(cancelledValueDateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")}
              {moment
                .utc(cancelledValueDateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD") !==
              moment
                .utc(cancelledValueDateRange.endDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")
                ? ` to ${moment
                    .utc(cancelledValueDateRange.endDate)
                    .utcOffset("+05:30")
                    .format("YYYY-MM-DD")}`
                : ""}
              <br />
              <strong>Cancelled Order Count: </strong>
              {cancelledCount}
              <br />
              <strong> Total Price (INR): </strong>
              {isNaN(parseFloat(cancelledPriceSum))
                ? 0
                : parseFloat(cancelledPriceSum).toFixed(2)}
            </Text>
          </AggregateSummary>
        </div>
        <div onClick={() => handleCardClick("RTO")}>
          <AggregateSummary title="RTO">
            <Text>
              <strong>Date: </strong>
              {moment
                .utc(rtoVlaueDateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")}
              {moment
                .utc(rtoVlaueDateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD") !==
              moment
                .utc(rtoVlaueDateRange.endDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")
                ? ` to ${moment
                    .utc(rtoVlaueDateRange.endDate)
                    .utcOffset("+05:30")
                    .format("YYYY-MM-DD")}`
                : ""}
              <br />
              <strong>RTO Count: </strong>
              {rtoCount}
              <br />
              <strong> Total Price (INR): </strong>
              {isNaN(parseFloat(rtoPriceSum))
                ? 0
                : parseFloat(rtoPriceSum).toFixed(2)}
            </Text>
          </AggregateSummary>
        </div>
        <div onClick={() => handleCardClick("Lost/Damaged")}>
          <AggregateSummary title="Lost/Damaged">
            <Text>
              <strong>Date: </strong>
              {moment
                .utc(lostDamagedDateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")}
              {moment
                .utc(lostDamagedDateRange.startDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD") !==
              moment
                .utc(lostDamagedDateRange.endDate)
                .utcOffset("+05:30")
                .format("YYYY-MM-DD")
                ? ` to ${moment
                    .utc(lostDamagedDateRange.endDate)
                    .utcOffset("+05:30")
                    .format("YYYY-MM-DD")}`
                : ""}
              <br />
              <strong>Lost/Damaged order Count: </strong>
              {lostDamagedCount}
              <br />
              <strong> Total Price (INR): </strong>
              {isNaN(parseFloat(getLostDamagedPriceSum))
                ? 0
                : parseFloat(getLostDamagedPriceSum).toFixed(2)}
            </Text>
          </AggregateSummary>
        </div>
      </div>
      {selectedCard === "Zero Value" && (
        <>
          <Row
            style={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "4%",
            }}
          >
            <Col style={{ marginRight: "1%"}}>
              <div className="d-flex">
                <ReactDatePicker
                  selected={startDate ? startDate : defaultStartDate}
                  onChange={(date) => setStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Start Date"
                />
                <ReactDatePicker
                  selected={endDate ? endDate : defaultEndDate}
                  onChange={(date) => setEndDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="End Date"
                />
                <Button
                  type="primary"
                  disabled={!startDate || !endDate}
                  onClick={handleZeroValueDateFilter}
                >
                  Submit
                </Button>
              </div>
            </Col>

            <Col>
              {/* Dropdown to select options */}
              <div className="d-flex align-items-center">
                <select
                  className="form-select me-3"
                  onChange={handleOptionChange}
                  value={selectedOption ? selectedOption : "Select an option"}
                >
                  <option value="">Select an option</option>
                  <option value="lost">Lost</option>
                  <option value="replacement">Replacement</option>
                  <option value="damaged">Damaged</option>
                  <option value="sample">Sample</option>
                  <option value="system">System</option>
                </select>
                {selectedOption && (
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                )}
              </div>
            </Col>
            <Col>
              <Button
                type="primary"
                style={{ marginLeft: "1%" }}
                icon={<DownloadOutlined />}
                onClick={handleZeroDownloadClick}
                disabled={!zeroValueData || zeroValueData.length === 0 || isDownloadDisabled}
              >
                Download
              </Button>
            </Col>
          </Row>
          <ZeroValueTable />
          <Drawer
            title="Activity Log Details"
            placement="right"
            closable={true}
            onClose={handleActivityLogDrawerClose}
            visible={isActivityLogDrawerVisible}
            width={600}
          >
            {Array.isArray(activityLogDrawerData) &&
            activityLogDrawerData.length > 0 ? (
              <List
                dataSource={activityLogDrawerData}
                renderItem={(log) => (
                  <List.Item key={log.id}>
                    <div className="activity-log-details">
                      <p>
                        <span className="activity-log-property-label">
                          User:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.author_name}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Event Id:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.event_id}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Created At:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {moment(log.created_at).format("D MMM YYYY, h:mm a")}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No activity log details available.</p>
            )}
          </Drawer>
          <Drawer
            title="Ticket Details"
            placement="right"
            closable={true}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            width={600}
          >
            {Array.isArray(drawerData) && drawerData.length > 0 ? (
              <List
                dataSource={drawerData}
                renderItem={(ticket) => (
                  <List.Item key={ticket.case_id}>
                    <div className="ticket-details">
                      <h3>Case ID: {ticket.case_id}</h3>
                      <p>
                        <span className="ticket-property-label">Priority:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.priority}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Category:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          Sub Category:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.sub_category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Status:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.status}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          customer Name:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.customer?.first_name}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No ticket details available.</p>
            )}
          </Drawer>
        </>
      )}
      {selectedCard === "Cancelled" && (
        <>
          <Row
            style={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "4%",
            }}
          >
            <Col style={{ marginRight: "1%" }}>
              <div className="d-flex">
                <ReactDatePicker
                  selected={startDate ? startDate : defaultStartDate}
                  onChange={(date) => setStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Start Date"
                />
                <ReactDatePicker
                  selected={endDate ? endDate : defaultEndDate}
                  onChange={(date) => setEndDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="End Date"
                />
                <Button
                  type="primary"
                  disabled={!startDate || !endDate || isDownloadDisabled}
                  onClick={handleCancelledDateFilter}
                >
                  Submit
                </Button>
              </div>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleCancelledDownloadClick}
                disabled={!cancelledData || cancelledData.length === 0}
              >
                Download
              </Button>
            </Col>
          </Row>
          <CancelledTable />
          <Drawer
            title="Activity Log Details"
            placement="right"
            closable={true}
            onClose={handleActivityLogDrawerClose}
            visible={isActivityLogDrawerVisible}
            width={600}
          >
            {Array.isArray(activityLogDrawerData) &&
            activityLogDrawerData.length > 0 ? (
              <List
                dataSource={activityLogDrawerData}
                renderItem={(log) => (
                  <List.Item key={log.id}>
                    <div className="activity-log-details">
                      <p>
                        <span className="activity-log-property-label">
                          User:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.author_name}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Event Id:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.event_id}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Created At:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {moment(log.created_at).format("D MMM YYYY, h:mm a")}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No activity log details available.</p>
            )}
          </Drawer>
          <Drawer
            title="Ticket Details"
            placement="right"
            closable={true}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            width={600}
          >
            {Array.isArray(drawerData) && drawerData.length > 0 ? (
              <List
                dataSource={drawerData}
                renderItem={(ticket) => (
                  <List.Item key={ticket.case_id}>
                    <div className="ticket-details">
                      <h3>Case ID: {ticket.case_id}</h3>
                      <p>
                        <span className="ticket-property-label">Priority:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.priority}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Category:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          Sub Category:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.sub_category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Status:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.status}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          customer Name:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.customer?.first_name}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No ticket details available.</p>
            )}
          </Drawer>
        </>
      )}
      {selectedCard === "RTO" && (
        <>
          <Row
            style={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "4%",
            }}
          >
            <Col style={{ marginRight: "1%" }}>
              <div className="d-flex">
                <ReactDatePicker
                  selected={startDate ? startDate : defaultStartDate}
                  onChange={(date) => setStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Start Date"
                />
                <ReactDatePicker
                  selected={endDate ? endDate : defaultEndDate}
                  onChange={(date) => setEndDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="End Date"
                />
                <Button
                  type="primary"
                  disabled={!startDate || !endDate || isDownloadDisabled}
                  onClick={handleRTODateFilter}
                >
                  Submit
                </Button>
              </div>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleRTODownloadClick}
                disabled={!rtoData || rtoData.length === 0}
              >
                Download
              </Button>
            </Col>
          </Row>
          <RtoTable />
          <Drawer
            title="Activity Log Details"
            placement="right"
            closable={true}
            onClose={handleActivityLogDrawerClose}
            visible={isActivityLogDrawerVisible}
            width={600}
          >
            {Array.isArray(activityLogDrawerData) &&
            activityLogDrawerData.length > 0 ? (
              <List
                dataSource={activityLogDrawerData}
                renderItem={(log) => (
                  <List.Item key={log.id}>
                    <div className="activity-log-details">
                      <p>
                        <span className="activity-log-property-label">
                          User:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.author_name}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Event Id:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.event_id}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Created At:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {moment(log.created_at).format("D MMM YYYY, h:mm a")}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No activity log details available.</p>
            )}
            {/* <Button onClick={handleShowMore}>Show More</Button> */}
          </Drawer>
          <Drawer
            title="Ticket Details"
            placement="right"
            closable={true}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            width={600}
          >
            {Array.isArray(drawerData) && drawerData.length > 0 ? (
              <List
                dataSource={drawerData}
                renderItem={(ticket) => (
                  <List.Item key={ticket.case_id}>
                    <div className="ticket-details">
                      <h3>Case ID: {ticket.case_id}</h3>
                      <p>
                        <span className="ticket-property-label">Priority:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.priority}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Category:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          Sub Category:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.sub_category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Status:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.status}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          customer Name:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.customer?.first_name}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No ticket details available.</p>
            )}
          </Drawer>
        </>
      )}
      {selectedCard === "Lost/Damaged" && (
        <>
          <Row
            style={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "4%",
            }}
          >
            <Col style={{ marginRight: "1%" }}>
              <div className="d-flex">
                <ReactDatePicker
                  selected={startDate ? startDate : defaultStartDate}
                  onChange={(date) => setStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Start Date"
                />
                <ReactDatePicker
                  selected={endDate ? endDate : defaultEndDate}
                  onChange={(date) => setEndDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="End Date"
                />
                <Button
                  type="primary"
                  disabled={!startDate || !endDate || isDownloadDisabled}
                  onClick={handleLostDamagedDateFilter}
                >
                  Submit
                </Button>
              </div>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handlelostDamagedDownloadClick}
                disabled={!LostDamagedData || LostDamagedData.length === 0}
              >
                Download
              </Button>
            </Col>
          </Row>
          <LostDamagedTable />
          <Drawer
            title="Activity Log Details"
            placement="right"
            closable={true}
            onClose={handleActivityLogDrawerClose}
            visible={isActivityLogDrawerVisible}
            width={600}
          >
            {Array.isArray(activityLogDrawerData) &&
            activityLogDrawerData.length > 0 ? (
              <List
                dataSource={activityLogDrawerData}
                renderItem={(log) => (
                  <List.Item key={log.id}>
                    <div className="activity-log-details">
                      <p>
                        <span className="activity-log-property-label">
                          User:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.author_name}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Event Id:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {log.event_id}
                        </span>
                      </p>
                      <p>
                        <span className="activity-log-property-label">
                          Created At:
                        </span>{" "}
                        <span className="activity-log-property-value">
                          {moment(log.created_at).format("D MMM YYYY, h:mm a")}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No activity log details available.</p>
            )}
          </Drawer>
          <Drawer
            title="Ticket Details"
            placement="right"
            closable={true}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            width={600}
          >
            {Array.isArray(drawerData) && drawerData.length > 0 ? (
              <List
                dataSource={drawerData}
                renderItem={(ticket) => (
                  <List.Item key={ticket.case_id}>
                    <div className="ticket-details">
                      <h3>Case ID: {ticket.case_id}</h3>
                      <p>
                        <span className="ticket-property-label">Priority:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.priority}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Category:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          Sub Category:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.sub_category}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">Status:</span>{" "}
                        <span className="ticket-property-value">
                          {ticket.status}
                        </span>
                      </p>
                      <p>
                        <span className="ticket-property-label">
                          customer Name:
                        </span>{" "}
                        <span className="ticket-property-value">
                          {ticket.customer?.first_name}
                        </span>
                      </p>
                    </div>
                  </List.Item>
                )}
              />
            ) : (
              <p>No ticket details available.</p>
            )}
          </Drawer>
        </>
      )}
    </>
  );
};

export default RevenueTracker;
